import {
    MANUFACTURERS_REFRESH_DEVICES_CONFIG_OPEN_MODAL,
    MANUFACTURERS_REFRESH_DEVICES_CONFIG_REQUEST,
    MANUFACTURERS_REFRESH_DEVICES_CONFIG_RESULT,
    MANUFACTURERS_REFRESH_DEVICE_CONFIG_REQUEST,
    MANUFACTURERS_REFRESH_DEVICE_CONFIG_RESULT,
} from 'Redux/actionTypes';

export const manufacturersRefreshDevicesConfigOpenModal = () => ({
    type: MANUFACTURERS_REFRESH_DEVICES_CONFIG_OPEN_MODAL
})

export const manufacturersRefreshDevicesConfigRequest = () => ({
    type: MANUFACTURERS_REFRESH_DEVICES_CONFIG_REQUEST,
})

export const manufacturersRefreshDevicesConfigResult = (result) => ({
    type: MANUFACTURERS_REFRESH_DEVICES_CONFIG_RESULT,
    payload: result
})

export const manufacturersRefreshDeviceConfigRequest = (unitId) => ({
    type: MANUFACTURERS_REFRESH_DEVICE_CONFIG_REQUEST,
    payload: { unitId: unitId }
})

export const manufacturersRefreshDeviceConfigResult = (result) => ({
    type: MANUFACTURERS_REFRESH_DEVICE_CONFIG_RESULT,
    payload: result
})